import {CheckoutHeaderType} from './CheckoutHeader.model';

export class CheckoutHeaderLogoModel {
  public size?: string;

  constructor(checkoutHeaderLogo?: NonNullable<CheckoutHeaderType>['logo']) {
    this.size = checkoutHeaderLogo?.size ?? /* istanbul ignore next */ undefined;
  }
}
